<template>
  <div>
    <div class="card">
      <div class="card-action white white-text"></div>
      <div class="card-content animated flipInX">
        <h5>Token re-issue</h5>
        <p>Enter your meter number and phone number below.</p>
        <form @submit.prevent="requestToken" id="form" style="margin-top: 30px">
          <div class="row">
            <div class="input-field col s12 m8 offset-m2">
              <input type="text" v-model="fields.receiver" id="meter_number" />
              <label for="meternumber">Meter Number</label>
            </div>
          </div>
          <div class="row">
            <div class="input-field col s12 m8 offset-m2">
              <input type="text" v-model="fields.phone" id="phone" />
              <label for="phone">Phone Number</label>
            </div>
          </div>
          <div class="row">
            <div v-if="reissue">
              <img src="ui/img/loading.svg" alt="Time Loader" />
              <p><i>Loading...</i></p>
            </div>
            <div class="col s12 m12" v-else>
              <button class="waves-effect waves-light btn-small" type="submit">
                Request Token
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
    <!-- Request Token -->
    <div id="requestToken" class="modal services">
      <div class="modal-header">
        <a class="modal-close waves-effect btn-small waves-green right">x</a>
      </div>
      <div class="modal-content">
        <img src="ui/img/success.png" width="12%" class="responsive-img" />
        <h6>{{ completed.title }}</h6>
        <h5>{{ completed.cust_name }}</h5>
        <h6>{{ completed.cust_address }}</h6>
        <h5>
          <strong>Token: {{ completed.token }}</strong>
        </h5>
        <button
          type="button"
          @click="doCopy"
          class="copyBtn btn-small"
          style="padding: 1px 7px; font-size: 11px;"
        >
          Click to copy
        </button>
        <h5>Units: {{ completed.units }}</h5>
        <p><strong>Transaction ID:</strong> {{ completed.transactionID }}</p>
      </div>
    </div>
    <!-- Request Token -->
  </div>
</template>
<script>
export default {
  name: 'RequestToken',
  mounted() {
    this.initModal()
    $('.bills__side__wrapper').removeClass('left_out')
    if (localStorage.getItem('phone') !== null) {
      var phone = localStorage.getItem('phone')
      this.fields.phone = phone
      $('#phone').val(phone)
    }
    if (localStorage.getItem('power') !== null) {
      var power = JSON.parse(localStorage.getItem('power'))
      if (power.message === 'Successful') {
        // if the transaction isn't empty for the user
        this.fields.receiver = power.receiver
        $('#meter_number').val(this.fields.receiver)
        this.fields.phone = power.phone
        $('#phone').val(this.fields.phone)
      }
    }
    M.updateTextFields()
  },
  data() {
    return {
      reissue: false,
      fields: {},
      modalInstance: {},
      completed: {}
    }
  },
  methods: {
    formatNumber(num) {
      var result = num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
      return result
    },
    initModal() {
      // initialize modal for the document
      const option = {
        dismissible: false,
        endingTop: '6%',
        preventScrolling: true
      }
      var elems = document.querySelectorAll('.modal.services')
      var instances = M.Modal.init(elems, option)
      this.modalInstance = instances
    },
    doCopy: function() {
      let container = this.$refs.container
      this.$copyText(this.completed.token, container)
      $('.copyBtn').text('Copied')
      setTimeout(() => {
        $('.copyBtn').text('Click to copy')
      }, 3000)
    },
    requestToken() {
      if (this.ValidateData()) {
        this.reissue = true
        this.fields.passcode = this.hash(this.fields.receiver)
        this.axios
          .post('https://irecharge.com.ng/api/power/reissue.php', this.fields)
          .then(response => {
            if (response.data.status == 0) {
              this.completed.transactionID = response.data.transaction_id
              this.completed.title = response.data.title
              this.completed.cust_address = response.data.cust_address
              this.completed.cust_name = response.data.cust_name
              this.completed.token = this.spaceToken(
                response.data.token,
                4
              ).join('-')
              this.completed.units = response.data.units
              this.completed.amount = this.formatNumber(
                parseInt(response.data.amount)
              )
              this.modalInstance[0].open()
              this.reissue = false
              $('.toast').hide()
            } else {
              this.reissue = false
              $('.toast').hide()
              M.toast({ html: response.data.message, classes: 'info' })
            }
          })
          .catch(error => {
            $('.toast').hide()
            M.toast({
              html: 'Could not send request, check network.',
              classes: 'error'
            })
            this.reissue = false
          })
      }
    },
    ValidateData() {
      if (this.fields.receiver) {
        if (this.fields.phone) {
          if (this.fields.phone.toString().length === 11) {
            return true
          } else {
            $('.toast').hide()
            M.toast({
              html: 'Phone number must be 11 characters',
              classes: 'info'
            })
          }
        } else {
          $('.toast').hide()
          M.toast({ html: 'Phone number is required!', classes: 'info' })
        }
      } else {
        $('.toast').hide()
        M.toast({ html: 'Meter number is required!', classes: 'info' })
      }
    },
    hash(ref) {
      let passcode = '123NDSx'
      let encrypted = CryptoJS.HmacSHA512(ref, passcode)
      return encrypted.toString()
    },
    spaceToken(str, n) {
      var ret = []
      var i
      var len
      for (i = 0, len = str.length; i < len; i += n) {
        ret.push(str.substr(i, n))
      }
      return ret
    }
  }
}
</script>
<style scoped>
label {
  font-size: 1rem;  
  color: #9e9e9e;
  font-weight: bold;
}
.card-content {
  padding: 0px 24px 24px;
}
.card .card-action {
  padding: 6px 24px;
}
.input-field {
  margin-top: 0px;
}
</style>
